import { CommonHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const PutNcaaAthleteData = (putNcaaAthleteObj, state, setState) => {
  if (state.isSaving !== true && !state.message) {
    const newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Saving...'
    };
    setState(newState);

    const url = `/OrgUnit/OtherOrganization/Ncaa/Athlete`;
    CommonHttpHelper(url, 'PUT', putNcaaAthleteObj)
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoaded: true,
            isSaving: false,
            isSaved: true,
            arrayData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoaded: false,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};

export default PutNcaaAthleteData;